import{mixNumber as o}from"../mix/number.mjs.js";import{progress as r}from"../progress.mjs.js";function s(s,m){const t=s[s.length-1];for(let n=1;n<=m;n++){const e=r(0,m,n);s.push(o(t,1,e))}}export{s as fillOffset};
